import { PdfData } from "./types";

const FoodSafetyData: PdfData = {
  title: "Food Safety Issues",
  description: {
    i18nKey: "food_safety_description",
    label:
      "Please note here the details of safety issues, congrats! No need to report it. However, for “presence of extraneous material in the food”, report the incident only if the material has been in the child’s mouth or ingested by the child (if it was found and removed before the child has eaten it, congrats! no need to report it)",
  },
  fields: [
    {
      name: "eventDate",
      label: "Event Date",
    },
    {
      name: "type",
      label: "Type",
    },
    {
      name: "cause",
      label: "Cause",
    },
    {
      name: "actionTaken",
      label: "Actions Taken",
    },
  ],
};

export default FoodSafetyData;
